import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import css from './App.css';
import reportWebVitals from './reportWebVitals';
import serialsJson from './data/serials.json';

const HTK_BACKEND = process.env.REACT_APP_HTK_BACKEND || window._env_.REACT_APP_HTK_BACKEND;
const HTK_ASSETS = process.env.REACT_APP_HTK_ASSETS || window._env_.REACT_APP_HTK_ASSETS;
const HTK_CDN = process.env.REACT_APP_HTK_CDN || window._env_.REACT_APP_HTK_CDN;
// const HTK_API_GOOGLE = process.env.REACT_APP_HTK_API_GOOGLE || window._env_.REACT_APP_HTK_API_GOOGLE;
// const HTK_CDN_SIMU = process.env.REACT_APP_HTK_CDN_SIMU || window._env_.REACT_APP_HTK_CDN_SIMU;

// const HTK_BACKEND = "https://qweb.hightek.it/";
// const HTK_ASSETS = "https://qcdn.hightek.it/";
// const HTK_CDN = "https://qcdn.hightek.it/v2/";
// const HTK_CDN_SIMU = "https://185.203.25.236:81/simu/v2/";
// const HTK_BACKEND = "http://qcenter.hightek.local:3500";
// const HTK_CDN = "http://185.203.25.236:81/simu/v2/";
// htkCDNSimu={HTK_CDN_SIMU}

ReactDOM.render(
  <React.StrictMode>
    <App
      sns={[]}
      htkCDN={HTK_CDN}

      htkBackend={HTK_BACKEND}
      htkAssets={HTK_ASSETS}
      htkApiMaps={"AIzaSyBS4-irfJhThd3xzM0cb1fFMKWMSA3pQ_g"}

      htkSimu = "SIMU-P020001/history.json"
      htkSimuSerial = ""
      snsJson = {serialsJson} timePolling={1000}
      startPosition = {[40.783712,14.698841]}
      htkBackendEmail={"https://qweb.hightek.it/sendMailQLive"}
      


      // PREFISSO url streaming H265
      htkVideoStreamingH265={"https://dev-livestreaming.hightek.it/hightek"}         // attuale

      // PREFISSO url streaming H264
      htkVideoStreamingH264={"https://dev-livestreaming.hightek.it/h264/hightek"}         // attuale

      // PREFISSO url streaming Drone
      // https://livestreaming.hightek.it/hightek/Cicalese/index.m3u8
      htkVideoStreamingDrone={"https://dev-livestreaming.hightek.it/hightek"}         // attuale

      // PREFISSO url streaming Barca
      htkVideoStreamingBarca={"https://dev-livestreaming.hightek.it/ecodrone"}         // attuale

      accessMode = {false}
      
      /*

        1)Quando aggiungi un nuovo seriale che deve avere lo streaming, devi aggiungerlo all'array serialiStreaming.
        
        2)Quando aggiungi un nuovo seriale che deve avere lo streaming, oltre ad aggiungerlo all'array serialiStreaming, 
          scegli il tipo di streaming tra:
          -streamingH265  (se elicottero con streaming H265)
          -streamingH264  (se elicottero con streaming H264)
          -streamingDrone  (se drone con streaming Drone)
          -streamingBarca (se barca con streaming Barca)

      */

      // filtraggio tra chi ha lo streaming e chi no
      serialiStreaming = {['AB-Q10000','AA-Q10000','AA-D10000','AA-D10001','AA-QG1000S','AA-QG1001S','AA-QG1002S','1581F5BKD238R00E76RZ','1581F62HD234K00C9R50','1581F5BKD23AM00F8PJZ','YCBZTZ00094202','1581F7K3C24C600AK14Y']}   //attuale


      // filtraggio tra chi ha lo streaming H265, chi ha lo streaming H264, chi ha lo streaming Drone, chi ha lo streaming Barca (attuale -> produzione)

      // se il seriale corrente è un elicottero con streaming H265
      streamingH265={['AA-QG1000S','AA-QG1001S','AA-QG1002S','AA-D10001','1581F5BKD238R00E76RZ','1581F62HD234K00C9R50','1581F5BKD23AM00F8PJZ','YCBZTZ00094202']}         // ATTUALE
      
      // se il seriale corrente è un elicottero con streaming H264
      streamingH264={['AA-D10000','AA-Q10000','AB-Q10000']}          // ATTUALE

      // se il seriale corrente è un drone con streaming drone
      streamingDrone = {['1581F7K3C24C600AK14Y']}   // attuale per il filtraggio

      // se il seriale corrente è una barca con streaming barca
      streamingBarca = {[]}

    />
  </React.StrictMode>,
  document.getElementById('root')
);

// AA-0242ac1e0003
// AA-001e06422518
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
